import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { RecentTrip, Site, StorageService, BrowserHelper, LocationHelper, ConfigService } from 'src/app/main';
import isWebview from 'is-ua-webview';

@Component({
    selector: 'app-guanabara-home',
    templateUrl: './guanabara-home.component.html',
    encapsulation: ViewEncapsulation.None
})
export class GuanabaraHomeComponent implements OnInit {
    recentTrips: RecentTrip[] = [];
    showCovidModalMessage: boolean = true;
    isMobile: boolean = false;
    isWebview: boolean = false;

    get siteConfig():Site{
        return this.configService.siteConfig;
    }

    constructor(
        private bookingProcessStorage: StorageService,
        private router: Router,
        public browserHelper: BrowserHelper,
        public configService: ConfigService
    ) {
    }

    public ngOnInit(): void {
        this.isMobile = this.browserHelper.runningOnMobile();
        this.recentTrips = this.bookingProcessStorage.getRecentTrips();
        this.isWebview = isWebview(navigator.userAgent);
    }

    onRecentTripSelected = (trip: RecentTrip): void => {
        this.bookingProcessStorage.clear();
        this.router.navigate([`/onibus/${LocationHelper.beautifyLocationName(trip.departureLocationCode)}/${LocationHelper.beautifyLocationName(trip.arrivalLocationCode)}`])
    }

    onRecentTripRemoved = (trip: RecentTrip): void => {
        this.bookingProcessStorage.removeRecentTrip(trip);
        this.recentTrips = this.bookingProcessStorage.getRecentTrips();
    }

    setCovidModalMessage() {
        this.showCovidModalMessage = false;
    }

    desktopBannerStyles = {
        'width': '100%',
        'min-height': '550px'
    };

    mobileBannerStyles = {
        'width': '100%'
    };

    get bannerStyles() {
        return this.isMobile ? this.mobileBannerStyles : this.desktopBannerStyles;
    }
}
